export const SET_CLIPBOARD = 'SET_CLIPBOARD';
export const GET_CLIPBOARD = 'GET_CLIPBOARD';
export const CLEAR_CLIPBOARD = 'CLEAR_CLIPBOARD';
export const SET_CURRENT_USER = 'SET_CURRENT_USER';
export const SUBMIT_ENTRY = 'SUBMIT_ENTRY';
export const ENTERED = 'ENTERED';
export const TOGGLE_PARTNER_OPTIN = 'TOGGLE_PARTNER_OPTIN';
export const TOGGLE_LOADING = 'TOGGLE_LOADING';
export const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
